import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "./index.css";

import estrelaVazia from "../../assets/images/svg/estrelaVazia.svg";
import estrelaCheia from "../../assets/images/svg/estrelaCheia.svg";
import aspas from "../../assets/images/svg/aspas.svg";
import tituloReviews from "../../assets/images/png/tituloReviews.png";
import followUsEverywhere from "../../assets/images/svg/followUsEverywhere.svg";
import setaEsquerda from "../../assets/images/svg/setaEsquerda.svg";
import setaDireita from "../../assets/images/svg/setaDireita.svg";
import iconeInstagram from "../../assets/images/svg/iconeInstagram.svg";
import iconeTikTok from "../../assets/images/svg/iconeTikTok.svg";
import iconeYoutube from "../../assets/images/svg/iconeYouTube.svg";

export default function Reviews() {
  const navigate = useNavigate();
  const Cards = [
    {
      estrelas: 5,
      comentario: "Had fun at Clawz? Leave us a review and win 15 points to play in-store!",
      nome: "Clawz",
    },
    {
      estrelas: 5,
      comentario: "The staffs gave us lots of hints and even let me try a few times for practice! 😍You can have a lot of fun without any experience! If you catch lots of small plush, you can exchange it for a big one! It’s my first time here I had a really good time. Highly recommend everyone to come!!!😍 The shop even has clear backpacks for the plushies, so this big kid （me😂) can show off too.😂😂",
      nome: "chia ling pei",
    },
    {
      estrelas: 5,
      comentario: "¡Pasamos un excelente rato en familia! Mis niños quedaron encantados con todos sus peluches favoritos, y la atención fue espectacular. Un lugar divertido, visualmente hermoso y perfecto para disfrutar con los más pequeños. ¡Sin duda volveremos!",
      nome: "Zuzette Valdivia",
    },
    {
      estrelas: 5,
      comentario: "Amazing place to have fun and spend time with your kids. The ambiance, decorations and Claw machines are top notch, the team did a great job with the characters and licences. Can't wait to visit again",
      nome: "Guillermo Hermosillo",
    },
    {
      estrelas: 5,
      comentario: "Our next summer adventure with the kids take us to Clawz Plushies Playground located inside of International mall in Doral Opening its doors last week, it is every child's dream place. This place mixes two different styles: Japanese and South Korean. The sound of the machines attracts the attention of the little ones in the family, the colors, The options for visitors to fill themselves with gifts are perfect. High recommended place for kids.",
      nome: "Vicente Albuerne",
    },
    {
      estrelas: 5,
      comentario: "the place was so cute and so fun 😛 there was so many cute options AND MOST IMPORTANTLY THE WORKERS ARE SOOOOOO NICE❤️‍🩹❤️‍🩹 one of them kept giving me free chances …",
      nome: "alexa",
    },
    {
      estrelas: 5,
      comentario: "WOW !!! I love this place ❤️ 💕 super cute for the kiddies . I love the fact that even if you don't win, they give you a prize still. I love the fact that you can trade your prize for something similar. The place is super cute . It's nice for what it is, they give you that japan claw machince experience. The staff is friendly and attentive.",
      nome: "chi ch i",
    },
    {
      estrelas: 5,
      comentario: "Great for kids and adults! It brought the child out in me! Beautifully decorated, very attentive staff, and adorable plushies",
      nome: "Carolina Rocha",
    },
    {
      estrelas: 5,
      comentario: "Clawz was such a fun place for the kids. Everyone wins a prize and you can trade up your prizes for a bigger prize. Great concept! Great time!",
      nome: "Daniela Cavada",
    },
    {
      estrelas: 5,
      comentario: "I love this place my new favorite place !! The staff is amazing very friendly and welcoming 🩷❤️definitely recommend it .. …",
      nome: "Mariam Fuentes",
    },
  ];
  const swiper = useRef(null);
  const handlePrevClick = () => {
    swiper.current?.swiper.slidePrev();
  };

  const handleNextClick = () => {
    swiper.current?.swiper.slideNext();
  };
  return (
    <div className="reviews-container">
      <div className="container d-flex justify-content-center align-items-center py-5">
        <img
          className="setaCards"
          src={setaEsquerda}
          alt="Previous review slide"
          onClick={handlePrevClick}
        />
        <img
          width={"30%"}
          src={tituloReviews}
          alt="Clawz Entertainment Customer Reviews"
        />
        <img
          className="setaCards"
          src={setaDireita}
          alt="Next review slide"
          onClick={handleNextClick}
        />
      </div>
      <Swiper
        ref={swiper}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1400: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
        }}
        loop={true}
    
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {Cards.map((card, index) => (
          <SwiperSlide key={index}>
            <div className="review-card" style={{ cursor: "grab" }}>
              <div className="d-flex justify-content-between">
                <img src={aspas} alt="aspas" />
                <div className="review-stars">
                  {[...Array(5)].map((_, i) => (
                    <img
                      key={i}
                      src={card.estrelas >= i + 1 ? estrelaCheia : estrelaVazia}
                      alt={
                        card.estrelas >= i + 1
                          ? "estrela cheia"
                          : "estrela vazia"
                      }
                    />
                  ))}
                </div>
              </div>
              <div
                className="d-flex flex-column justify-content-between"
                style={{ minHeight: "150px" }}
              >
                <div className="review-comment">{card.comentario}</div>
                <div className="review-author">{card.nome}</div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="social-media-container">
        <img
          className="social-media-title"
          src={followUsEverywhere}
          alt="followUsEverywhere"
        />

        <div className="social-media-links">
          <a
            className="social-media-link"
            href="https://www.instagram.com/clawz.us"
            target="_blank"
          >
            <img
              title="Instagram"
              className="social-media-icon"
              src={iconeInstagram}
              alt="iconeInstagram"
            />
          </a>
          <a
            className="social-media-link"
            href="https://www.tiktok.com/@clawz.us"
            target="_blank"
          >
            <img
              title="TikTok"
              className="social-media-icon"
              src={iconeTikTok}
              alt="iconeTikTok"
            />
          </a>
          <a
            className="social-media-link"
            href="https://www.youtube.com/@clawzplushiesplayground"
            target="_blank"
          >
            <img
              title="YouTube"
              className="social-media-icon"
              src={iconeYoutube}
              alt="iconeYoutube"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
